module.exports = __webpack_public_path__ + "img/wait.8784217d.png";